<template>
  <div class="h-full overflow-auto" :class="$style['landing-background']">
    <PublicLandingHeader
      :title="appSettingsStore.applicationTitle"
      subtitle="Hawaii State Environmental Health Administration Safe Drinking Water Branch"
      light
    />

    <PublicLandingContainer class="grid justify-stretch md:justify-center 2xl:max-w-screen-2xl">
      <PublicLandingBackdrop light class="grid grid-cols-1 gap-10">
        <PublicLandingOnlineServices
          class=""
          title="Internal Services"
          body="The Drinking Water System provides online employee access to Underground Injection Control (UIC) program permits, facilities, and wells."
          hide-register
        ></PublicLandingOnlineServices>

        <PublicLandingCard>
          <PublicLandingCardSection label="Permits">
            <PublicLandingParagraph>Find, view, and manage UIC permits and permit exemptions.</PublicLandingParagraph>
            <PublicLandingList>
              <PublicLandingListItem label="Review and approve submitted permit application forms" />
              <PublicLandingListItem label="Issue permits and permit exemptions" />
              <PublicLandingListItem label="Manage permitted wells, injection limits, and reports" />
            </PublicLandingList>
          </PublicLandingCardSection>

          <PublicLandingCardSection label="Facilities">
            <PublicLandingParagraph>Find, view, and manage UIC facilities.</PublicLandingParagraph>
            <PublicLandingList>
              <PublicLandingListItem label="Manage facility locations, including wells" />
              <PublicLandingListItem label="Monitor facility permitting activities" />
              <PublicLandingListItem label="Track facility owners and operators" />
            </PublicLandingList>
          </PublicLandingCardSection>

          <PublicLandingCardSection label="Wells">
            <PublicLandingParagraph>Find, view, and manage underground injection wells.</PublicLandingParagraph>
            <PublicLandingList>
              <PublicLandingListItem label="Manage well locations" />
              <PublicLandingListItem label="Track well permitting activities" />
              <PublicLandingListItem label="Monitor well dimensions and status" />
            </PublicLandingList>
          </PublicLandingCardSection>
        </PublicLandingCard>
      </PublicLandingBackdrop>
    </PublicLandingContainer>

    <MdrnFooter light black-and-white />
  </div>
</template>

<script lang="ts">
import { InitialBadge } from "@modernary/mui/components/badge";
import { BaseButton } from "@modernary/mui/components/button";
import { MdrnFooter, NoneFoundFlag, useAppNav, useAppSettingsStore } from "@modernary/mui/components/common";
import { LoginButton, LogoutButton, RegisterButton } from "@modernary/mui/utils/authentication/buttons";
import { computed, defineComponent } from "vue";

import {
  PublicLandingBackdrop,
  PublicLandingCard,
  PublicLandingCardSection,
  PublicLandingContainer,
  PublicLandingHeader,
  PublicLandingLinkCard,
  PublicLandingList,
  PublicLandingListItem,
  PublicLandingOnlineServices,
  PublicLandingParagraph,
} from "@modernary/mui/components/publicLanding";
import { routeNames } from "@/routes";

// Home content for unauth'd users
export default defineComponent({
  name: "HomePublic",
  setup() {
    const appSettingsStore = useAppSettingsStore();

    return { BaseButton, appSettingsStore, routeNames };
  },
  components: {
    BaseButton,
    InitialBadge,
    LoginButton,
    RegisterButton,
    MdrnFooter,
    NoneFoundFlag,
    LogoutButton,
    PublicLandingCard,
    PublicLandingCardSection,
    PublicLandingList,
    PublicLandingListItem,
    PublicLandingParagraph,
    PublicLandingLinkCard,
    PublicLandingOnlineServices,
    PublicLandingHeader,
    PublicLandingContainer,
    PublicLandingBackdrop,
  },
});
</script>

<style lang="css" module>
.landing-background {
  background-color: #111240; /* average color from the sky of the bg */
  background-image: url("/images/backgrounds/bg-dws.jpg");
  background-size: cover;
  background-position: left 0;
  background-repeat: no-repeat;
}
</style>
